export const getColumns = (intl, role_types) => [
  {
    title: "ID",
    field: "id",
    editable: "never",
    defaultSort: "desc",
    cellStyle: { fontSize: 12, padding: 0, minWidth: 100 },
  },
  {
    title: intl.formatMessage({ id: "name" }),
    field: "firstname",
    editable: "never",
    headerStyle: { minWidth: 200, fontWeight: "bold" },
    cellStyle: {
      fontSize: 12,
      padding: 0,
      minWidth: 200,
      textTransform: "uppercase",
      fontWeight: "bold",
    },
  },
  {
    title: intl.formatMessage({ id: "name" }),
    field: "lastname",
    editable: "never",
    headerStyle: { minWidth: 200, fontWeight: "bold" },
    cellStyle: {
      fontSize: 12,
      padding: 0,
      minWidth: 200,
      textTransform: "uppercase",
      fontWeight: "bold",
    },
  },
  {
    title: intl.formatMessage({ id: "user_type" }),
    field: "role",
    lookup: role_types,
    editable: "never",
  },
  {
    title: "CAP",
    field: "zip_code",
  },
  {
    title: "Città",
    field: "city",
  },
  {
    title: "Provincia",
    field: "des_province",
  },
  {
    title: "E-mail",
    field: "email",
  }
];

export const OPTIONS = {
  selection: true,
  filtering: true,
  pageSize: 10,
  searchFieldAlignment: "left",
  searchFieldStyle: {
    marginTop: "2px",
  },
  showTitle: false,
  toolbar: false,
  filterCellStyle: { maxWidth: 250 },
  headerStyle: { whiteSpace: "nowrap", fontWeight: "bold" },
  cellStyle: { fontSize: 12, padding: 0, textTransform: "uppercase" },
};

export const getLocalization = (intl) => ({
  header: {
    actions: "",
  },
  body: {
    editRow: {
      deleteText: intl.formatMessage({ id: "delete_user" }),
    },
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} of {count} users",
    labelRowsSelect: "Users",
  },
});
